import { ReactNode } from "react";
import { Button, Text, View } from "./base";
import { Dialog } from "./base/Dialog";
import clsx from "clsx";

export type ConfirmDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  children?: ReactNode;
  variant?: "danger" | "warning";
};

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  isLoading = false,
  children,
  variant = "danger",
}: ConfirmDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
    >
      <View className="flex flex-col p-6">
        <Text className="text-gray-900 dark:text-white mb-4">{message}</Text>
        {children}
      </View>
      <View className="flex items-center justify-end p-6 gap-3 border-t border-gray-200 dark:border-gray-700">
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
          isDisabled={isLoading}
        >
          {cancelLabel}
        </Button>
        <Button
          type="button"
          onClick={onConfirm}
          isLoading={isLoading}
          className={clsx(
            variant === "danger"
              ? "!bg-red-600 !text-white hover:!bg-red-700"
              : "text-yellow-600 hover:text-yellow-700 border-yellow-300 hover:border-yellow-400 dark:text-yellow-400 dark:border-yellow-800 dark:hover:border-yellow-700",
          )}
        >
          {confirmLabel}
        </Button>
      </View>
    </Dialog>
  );
};
